// Keep SERP snippets readable (mirror of scripts/prerender.js).
export const seoTitle = (t) => `${t} — FOD by DMB Partners`;

export function seoDescription(d) {
    const s = String(d || "").replace(/\s+/g, " ").trim();
    if (s.length <= 158) return s;
    return s.slice(0, 155).replace(/\s+\S*$/, "") + "…";
}
